<template>
    <div>
        <h1>Account Status</h1>
        <div v-if="user.tier === 'Premium'" class="mt-4 ml-4 text-lg">
            <div class="text-lg">
                Premium Pro Subscriber
                </div>
            <div class="text-lg">
                {{ subscriptionStatus() }}
            </div>
            <div>
                <a href="/billing">
                    <button class="primary-btn px-14 mt-4 mb-4">
                        Account Details
                    </button>
                </a>
            </div>
        </div>
        <div v-else-if="user.type === 'pro'" class="mt-4 ml-4">
            <div class="text-lg">
                Pro (Free)
            </div>
            <div v-if="wasPremium()">
                <a href="/billing">
                    <button class="primary-btn px-14 mt-4 mb-4">
                        Account Details
                    </button>
                </a>
            </div>
            <a
                id="upgrade-to-premium"
                title="Switch To Premium"
                href="/premium-switch/"
            >
                <button>
                    <svg-vue
                        icon="Go Premium Button"
                        class="h-10 mt-4 mb-4 mr-2 ml-5 fill-white"
                    />
                </button>
            </a>
        </div>
        <div v-else class="mt-4 ml-4">
            <div class="text-lg">
                Customer (Free)
            </div>
            <a
                id="upgrade-to-pro"
                title="Switch To Pro"
                href="/pro-switch/"
            >
                <button>
                    <svg-vue
                        icon="Go Pro Button"
                        class="h-10 mt-4 mb-4 mr-2 ml-5 fill-white"
                    />
                </button>
            </a>
        </div>

    </div>
</template>

<script>
export default {
    name: "AccountStatus",
    props: ['user'],
    data() {
        return {
            subscription: this.activeSubscription(),
        }
    },
    mounted() {
        console.log( this.user.tier);
        if( this.subscription) {
            console.log( this.subscription);

            console.log( this.subscription.stripe_status);
            console.log( this.subscription.ends_at);
            console.log( this.subscription.created_at);

        } else
            console.log( 'not subscribed');
    },
    methods: {
        subscriptionStatus(){
            if( this.subscription){
                return this.startDate( this.subscription)
                    + this.trialEnds( this.subscription)
                    + this.endDate( this.subscription);
            } else {
                return "No current subscription";
            }
        },
        wasPremium(){
            if( this.user.subscriptions == null) return false;
            if( this.activeSubscription() == null) return false;
            return true;
        },
        activeSubscription(){
            let subscription;
            for( subscription of this.user.subscriptions){
                if( subscription.stripe_status === 'active'
                     || subscription.stripe_status === 'trialing')
                    return subscription;
            }
            return null;
        },
        endDate( subscription){
            if( subscription.ends_at)
                return " End date: " + this.simpleDateFormat( subscription.ends_at);
            return "";
        },
        trialEnds( subscription){

            if( subscription.stripe_status === 'trialing')
                return " Trial Ends: " + this.simpleDateFormat( subscription.trial_ends_at);
            return "";
        },
        startDate( subscription){
            return " Started on: " + this.simpleDateFormat( subscription.created_at);
        },
        simpleDateFormat( dateString){
            const date = new Date( dateString);
            console.log( date);
            return (date.getMonth() + 1) + '/'
                     + date.getDate() + '/'
                     + date.getFullYear();
        }
    },
}
</script>

<style scoped>

</style>
